import * as React from 'react';
export const usageSvg = React.forwardRef(function usageSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.875 7a4.875 4.875 0 1 0-8.982 2.625h8.214A4.846 4.846 0 0 0 10.875 7ZM12 7a5.975 5.975 0 0 1-1.316 3.75H1.316l-.151-.196A6 6 0 1 1 12 7Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.933 4.516a.581.581 0 0 1 .98.43.581.581 0 0 1-.156.394L6.072 8.224a.722.722 0 0 1-1.042.019.721.721 0 0 1 .02-1.043l2.884-2.685Z',
    }),
  );
});
usageSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usage = {
  category: 'icon',
  colorable: true,
  name: 'usage',
  svg: usageSvg,
};
